import Button from '@mui/material/Button'
import Icon from '@mui/material/Icon'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'

import { CenteredContainer, exitButtonOptions } from './common'

type Props = {
  onMenuItemClick: (status: 'save' | 'exit') => void
}

const SurveyCompleted: React.FC<Props> = ({ onMenuItemClick }) => (
  <CenteredContainer
    id="cati-survey-no-more-questions-cont"
    data-testid="survey-completed-container"
    sx={{ mt: '70px' }}
  >
    <EndBoxContainer>
      <EndIcon>task_alt</EndIcon>
      <EndTitleText variant="h4">This survey is now done.</EndTitleText>
      <ButtonsContainer>
        {exitButtonOptions.map((option) => (
          <Tooltip key={option.id} title={option.tooltip}>
            <Button
              id={option.id}
              color="primary"
              sx={{ mx: '5px', width: '100%' }}
              variant="contained"
              onClick={() => onMenuItemClick(option.status)}
            >
              {option.exitLabel}
            </Button>
          </Tooltip>
        ))}
      </ButtonsContainer>
    </EndBoxContainer>
  </CenteredContainer>
)

const EndBoxContainer = styled('div')({
  maxWidth: '580px',
  textAlign: 'center',
  margin: 'auto',
  boxShadow: '0px 0px 0px 1px rgb(224 224 224)',
  padding: '30px',
})

const EndTitleText = styled(Typography)({
  marginTop: '20px',
})

const EndIcon = styled(Icon)({
  fontSize: '6rem !important',
})

const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 30,
  gap: 8,

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}))

export default SurveyCompleted
